var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    [
      _c(
        "fieldset",
        [
          _c(
            "ItpFormGroup",
            {
              attrs: {
                name: "service",
                label: _vm._f("pgettext")("Service", "ContractService"),
                labelColsMd: "3",
                contentColsMd: "9",
                labelAlign: _vm.labelAlign,
                helpTooltip: _vm._f("pgettext")(
                  "Select the product or service the invoice line refers to.",
                  "ContractService|Tooltip"
                ),
                required: ""
              }
            },
            [
              _c("ItpFormSelect2", {
                attrs: {
                  name: "client",
                  "bind-object": "",
                  options: _vm.services,
                  textField: "name",
                  readonly: _vm.readonly
                },
                on: {
                  optionSelected: function($event) {
                    return _vm.evh_6466705138206980_optionSelected($event, {})
                  }
                },
                model: {
                  value: _vm.item.service,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "service", $$v)
                  },
                  expression: "item.service"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ItpFormGroup",
            {
              attrs: {
                labelColsMd: "3",
                contentColsMd: "9",
                name: "invoice_group_id",
                label: _vm._f("pgettext")("Invoice Group", "ContractService"),
                labelAlign: _vm.labelAlign,
                helpTooltip: _vm._f("pgettext")(
                  "The invoice group this service belongs to.",
                  "ContractService|Tooltip"
                )
              }
            },
            [
              _c("ItpFormSelect2", {
                attrs: {
                  name: "invoice_group_id",
                  multiple: _vm.b_3943151158818434_multiple,
                  options: _vm.invoiceGroups,
                  valueField: "id",
                  textField: "name",
                  clearable: "",
                  readonly: _vm.readonly
                },
                model: {
                  value: _vm.item.invoice_group_id,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "invoice_group_id", $$v)
                  },
                  expression: "item.invoice_group_id"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ItpFormGroup",
            {
              attrs: {
                labelColsMd: "3",
                name: "intermediated_service",
                label: _vm._f("pgettext")(
                  "Intermediated service",
                  "ContractService"
                ),
                labelAlign: _vm.labelAlign,
                helpTooltip: _vm._f("pgettext")(
                  "Select this option if the service is provided via an intermediary party.",
                  "ContractService|Tooltip"
                )
              }
            },
            [
              _c("ItpFormCheckbox", {
                attrs: {
                  name: "intermediated_service",
                  readonly: _vm.readonly
                },
                model: {
                  value: _vm.item.intermediated_service,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "intermediated_service", $$v)
                  },
                  expression: "item.intermediated_service"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ItpFormGroup",
            {
              attrs: {
                name: "valid_from",
                label: _vm._f("pgettext")("Valid from", "ContractService"),
                labelColsMd: "3",
                contentColsMd: "4",
                labelAlign: _vm.labelAlign,
                helpTooltip: _vm._f("pgettext")(
                  "Specifies the start date of the service period.",
                  "ContractService|Tooltip"
                )
              }
            },
            [
              _c("ItpFormDatetime", {
                attrs: {
                  name: "valid_from",
                  required: "",
                  readonly: _vm.readonly
                },
                model: {
                  value: _vm.item.valid_from,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "valid_from", $$v)
                  },
                  expression: "item.valid_from"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ItpFormGroup",
            {
              attrs: {
                name: "valid_to",
                label: _vm._f("pgettext")("Valid to", "ContractService"),
                labelColsMd: "3",
                contentColsMd: "4",
                labelAlign: _vm.labelAlign,
                helpTooltip: _vm._f("pgettext")(
                  "The service end date. Set only if it's different from the contract's end date.",
                  "ContractService|Tooltip"
                )
              }
            },
            [
              _c("ItpFormDatetime", {
                attrs: { name: "valid_to", readonly: _vm.readonly },
                model: {
                  value: _vm.item.valid_to,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "valid_to", $$v)
                  },
                  expression: "item.valid_to"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ItpFormGroup",
            {
              attrs: {
                name: "valid_to",
                label: _vm._f("pgettext")("Description", "ContractService"),
                labelColsMd: "3",
                contentColsMd: "9",
                labelAlign: _vm.labelAlign,
                helpTooltip: _vm._f("pgettext")(
                  "Internal notes for reference only. Not visible externally.",
                  "ContractService|Tooltip"
                )
              }
            },
            [
              _c("ItpFormTextarea", {
                attrs: {
                  name: "description",
                  readonly: _vm.readonly,
                  rows: "5"
                },
                model: {
                  value: _vm.item.description,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "description", $$v)
                  },
                  expression: "item.description"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "fieldset",
        [
          _c("legend", [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm._f("pgettext")(
                    "Invoicing",
                    "ContractServiceEditor|Section"
                  )
                ) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "ItpFormGroup",
            {
              attrs: {
                labelColsMd: "3",
                contentColsMd: "6",
                name: "billing_category",
                label: _vm._f("pgettext")(
                  "Billing category",
                  "ContractService"
                ),
                labelAlign: _vm.labelAlign,
                helpTooltip: _vm._f("pgettext")(
                  "The invoice category this service should be assigned to when billed. New values entered will be saved for future use.",
                  "ContractService|Help|BillingCategory"
                )
              }
            },
            [
              _c("ItpFormSelect2", {
                attrs: {
                  name: "billing_category",
                  taggable: "",
                  options: _vm.billingCategories,
                  readonly: _vm.item.readonly,
                  valueField: "name",
                  textField: "name"
                },
                model: {
                  value: _vm.item.billing_category,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "billing_category", $$v)
                  },
                  expression: "item.billing_category"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ItpFormGroup",
            {
              attrs: {
                name: "name",
                label: _vm._f("pgettext")("Name", "ContractService"),
                labelColsMd: "3",
                contentColsMd: "9",
                labelAlign: _vm.labelAlign,
                helpTooltip: _vm._f("pgettext")(
                  "This text will appear on the invice line.",
                  "ContractService|Tooltip"
                ),
                required: ""
              }
            },
            [
              _c("ItpFormInput", {
                attrs: { name: "name", required: "", readonly: _vm.readonly },
                model: {
                  value: _vm.item.name,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "name", $$v)
                  },
                  expression: "item.name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ItpFormGroup",
            {
              attrs: {
                name: "name",
                label: _vm._f("pgettext")("Name(s)", "ContractService"),
                labelColsMd: "3",
                contentColsMd: "9",
                labelAlign: _vm.labelAlign,
                helpTooltip: _vm._f("pgettext")(
                  "This text will appear on the invice line.",
                  "ContractService|Tooltip"
                ),
                required: ""
              }
            },
            [
              _c("UCContractServiceItemNameEditor", {
                attrs: { readonly: _vm.readonly },
                model: {
                  value: _vm.item.invoice_item_name,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "invoice_item_name", $$v)
                  },
                  expression: "item.invoice_item_name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ItpFormGroup",
            { attrs: { labelColsMd: "3", contentColsMd: "9" } },
            [_c("hr", { staticClass: "dots" })]
          ),
          _vm._v(" "),
          _c(
            "ItpFormGroup",
            {
              attrs: {
                name: "invoice_notes",
                label: _vm._f("pgettext")(
                  "Invoice notes",
                  "ContractServiceFee"
                ),
                labelColsMd: "3",
                contentColsMd: "9",
                labelAlign: _vm.labelAlign,
                helpTooltip: _vm._f("pgettext")(
                  "Note to display on the invoice line.",
                  "ContractService|Tooltip"
                )
              }
            },
            [
              _c("ItpFormTextarea", {
                attrs: { name: "fee_notes", readonly: _vm.readonly },
                model: {
                  value: _vm.item.invoice_notes,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "invoice_notes", $$v)
                  },
                  expression: "item.invoice_notes"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ItpFormGroup",
            {
              attrs: {
                name: "billing_frequency",
                label: _vm._f("pgettext")(
                  "Billing frequency",
                  "ContractService"
                ),
                labelColsMd: "3",
                contentColsMd: "3",
                labelAlign: _vm.labelAlign,
                helpTooltip: _vm._f("pgettext")(
                  "The cycle length of issuing the invoices.",
                  "ContractService|Tooltip"
                )
              }
            },
            [
              _c("BillingFrequencySelector", {
                attrs: { readonly: _vm.readonly },
                model: {
                  value: _vm.item.billing_frequency,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "billing_frequency", $$v)
                  },
                  expression: "item.billing_frequency"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ItpFormGroup",
            {
              attrs: {
                name: "billing_date_rule",
                label: _vm._f("pgettext")(
                  "Billing date rule",
                  "ContractService"
                ),
                labelColsMd: "3",
                contentColsMd: "9",
                labelAlign: _vm.labelAlign,
                helpTooltip: _vm._f("pgettext")(
                  "The cycle length of issuing the invoices.",
                  "ContractService|Tooltip"
                )
              }
            },
            [
              _c("BillingDateRuleFields", {
                attrs: { readonly: _vm.readonly },
                model: {
                  value: _vm.item.billing_date_rule,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "billing_date_rule", $$v)
                  },
                  expression: "item.billing_date_rule"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ItpFormGroup",
            { attrs: { labelColsMd: "3", contentColsMd: "9" } },
            [_c("hr", { staticClass: "dots" })]
          ),
          _vm._v(" "),
          _c(
            "ItpFormGroup",
            {
              attrs: {
                name: "due_date_rule",
                label: _vm._f("pgettext")("Due date rule", "ContractService"),
                labelColsMd: "3",
                contentColsMd: "9",
                labelAlign: _vm.labelAlign,
                helpTooltip: _vm._f("pgettext")(
                  "The rule of calculating the payment dates.",
                  "ContractService|Tooltip"
                )
              }
            },
            [
              _c("DueDateRuleFields", {
                attrs: { readonly: _vm.readonly },
                model: {
                  value: _vm.item.due_date_rule,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "due_date_rule", $$v)
                  },
                  expression: "item.due_date_rule"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ItpFormGroup",
            { attrs: { labelColsMd: "3", contentColsMd: "9" } },
            [_c("hr", { staticClass: "dots" })]
          ),
          _vm._v(" "),
          _c(
            "ItpFormGroup",
            {
              attrs: {
                name: "billing_currency",
                label: _vm._f("pgettext")(
                  "Billing currency",
                  "ContractService"
                ),
                labelColsMd: "3",
                contentColsMd: "3",
                labelAlign: _vm.labelAlign,
                helpTooltip: _vm._f("pgettext")(
                  "The currency to use on the invoice.",
                  "ContractService|Tooltip"
                )
              }
            },
            [
              _c("BillingCurrencySelector", {
                attrs: { readonly: _vm.readonly },
                model: {
                  value: _vm.item.billing_currency,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "billing_currency", $$v)
                  },
                  expression: "item.billing_currency"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ItpFormGroup",
            {
              attrs: {
                name: "exchange_rate_source",
                label: _vm._f("pgettext")(
                  "Exchange rate source",
                  "ContractService"
                ),
                labelColsMd: "3",
                contentColsMd: "3",
                labelAlign: _vm.labelAlign,
                helpTooltip: _vm._f("pgettext")(
                  "The currency exchange rate's provider.",
                  "ContractService|Tooltip"
                )
              }
            },
            [
              _c("ExchangeRateSourceSelector", {
                attrs: { readonly: _vm.readonly },
                model: {
                  value: _vm.item.exchange_rate_source,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "exchange_rate_source", $$v)
                  },
                  expression: "item.exchange_rate_source"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ItpFormGroup",
            {
              attrs: {
                name: "exchange_rate_source_spec",
                label: _vm._f("pgettext")(
                  "Exchange rate source specification",
                  "ContractService"
                ),
                labelColsMd: "3",
                contentColsMd: "3",
                labelAlign: _vm.labelAlign,
                helpTooltip: _vm._f("pgettext")(
                  "The currency exchange rate configuration.",
                  "ContractService|Tooltip"
                )
              }
            },
            [
              _c("ExchangeRateSourceSpecEditor", {
                attrs: { readonly: _vm.readonly },
                model: {
                  value: _vm.item.exchange_rate_source_spec,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "exchange_rate_source_spec", $$v)
                  },
                  expression: "item.exchange_rate_source_spec"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ItpFormGroup",
            {
              attrs: {
                name: "exchange_rate_date_rule",
                label: _vm._f("pgettext")(
                  "Exchange rate date rule",
                  "ContractService"
                ),
                labelColsMd: "3",
                contentColsMd: "9",
                labelAlign: _vm.labelAlign,
                helpTooltip: _vm._f("pgettext")(
                  "The date used to determine the exchange rate for billing purposes.",
                  "ContractService|Tooltip"
                )
              }
            },
            [
              _c("ExchangeRateDateRuleFields", {
                attrs: { readonly: _vm.readonly },
                model: {
                  value: _vm.item.exchange_rate_date_rule,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "exchange_rate_date_rule", $$v)
                  },
                  expression: "item.exchange_rate_date_rule"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }